import { LinksGroupComponent } from 'app/area/links-section/links-group';
import { LinksGroup } from 'app/area/links-section/types-store';
import * as React from 'react';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import styles from './links-groups.scss';

interface LinksGroupsProps {
  size?: string;
  linksGroups: LinksGroup[];
}

export function LinksGroups({ size, linksGroups }: LinksGroupsProps) {

  if (!linksGroups || linksGroups.length === 0) {
    return null;
  }

  return (<MainGridContainer>
    <div className={styles.linksGroupsContainer}>
      <div className={`row ${styles.linksGroups}`}>
        {linksGroups.map((linksGroup, index) => <LinksGroupComponent key={index} size={size} linksGroup={linksGroup} />)}
      </div>
    </div>
  </MainGridContainer>);
}
